// extracted by mini-css-extract-plugin
module.exports = {"title":"Clients_title__3zdzq","clients":"Clients_clients__yTTWW","list":"Clients_list__IyUuA","column":"Clients_column__3p6JL","logo":"Clients_logo__IvOMO"};